import type { CSS } from '../../stitches.config';
import type { SpacingScale } from './sizes';

export type MinHeightTypes = 'full' | 'screen' | SpacingScale | string;
export type MinHeightProps = { minHeight?: MinHeightTypes };

export const minHeightCSS = (minHeight?: MinHeightTypes): CSS => {
  if (minHeight === 'full') {
    return { minHeight: '100%' };
  }

  if (minHeight === 'screen') {
    return { minHeight: '100dvh' };
  }

  if (typeof minHeight === 'string' && (minHeight.includes('vh') || minHeight.includes('dvh'))) {
    return {
      minHeight: `${minHeight}`,
    };
  }

  if (minHeight != null) {
    return {
      minHeight: `$${minHeight}`,
    };
  }

  return {};
};
